var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showGroupTags,
            expression: "showGroupTags",
          },
        ],
        staticClass: "album-group__container",
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading",
              },
            ],
          },
          [
            _c("el-icon", {
              staticClass: "album-group__loading",
              attrs: { name: "loading" },
            }),
          ],
          1
        ),
        _vm._l(_vm.groupTags, function (groupTag) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.loading,
                  expression: "!loading",
                },
              ],
              key: groupTag.id,
              staticClass: "album-group",
              class: {
                "album-group--active":
                  _vm.selectedGroupTag.id == groupTag.groupTagId,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("select-group-tag", groupTag)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "album-group__content" },
                [
                  _c("div", { staticClass: "album-group__label" }, [
                    _c(
                      "div",
                      { staticClass: "icon-container" },
                      [
                        _c("el-icon", {
                          staticClass: "icon-folder",
                          class: {
                            "icon-folder--active":
                              _vm.selectedGroupTag.id == groupTag.groupTagId,
                          },
                          attrs: { name: "folder" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "album-group__name",
                        class: {
                          "album-group__name--active":
                            _vm.selectedGroupTag.id == groupTag.groupTagId,
                        },
                      },
                      [_vm._v(" " + _vm._s(groupTag.groupTagName) + " ")]
                    ),
                  ]),
                  _c(
                    "el-popconfirm",
                    {
                      attrs: {
                        title: !groupTag.groupTagId
                          ? "是否要刪除未分類相簿內所有照片？"
                          : "確定要刪除此相簿嗎?",
                        "confirm-button-text": "確認",
                        "cancel-button-text": "取消",
                      },
                      on: {
                        confirm: function ($event) {
                          return _vm.$emit(
                            "delete-group-tag",
                            groupTag.groupTagId
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "icon-container__delete",
                          attrs: { slot: "reference" },
                          slot: "reference",
                        },
                        [
                          _c("el-icon", {
                            staticClass: "icon-delete",
                            attrs: { name: "delete" },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        }),
      ],
      2
    ),
    _vm.albums && _vm.albums.length > 0
      ? _c(
          "div",
          {
            staticClass: "album-gallery",
            on: {
              "&scroll": function ($event) {
                return _vm.handleScroll($event)
              },
            },
          },
          [
            _vm.showSelection
              ? _c(
                  "el-checkbox-group",
                  {
                    attrs: { value: _vm.selectedImageIds },
                    on: {
                      input: function ($event) {
                        return _vm.$emit("update:selectedImageIds", $event)
                      },
                    },
                  },
                  [
                    _vm._l(_vm.albums, function (album) {
                      return _vm._l(album.files, function (file) {
                        return _c(
                          "el-checkbox",
                          { key: file.id, attrs: { label: file.id } },
                          [
                            _c("el-image", {
                              staticClass: "imgs",
                              attrs: { src: file.url },
                            }),
                          ],
                          1
                        )
                      })
                    }),
                  ],
                  2
                )
              : [
                  _vm._l(_vm.albums, function (album) {
                    return _vm._l(album.files, function (file) {
                      return _c("el-image", {
                        key: file.id,
                        staticClass: "imgs",
                        staticStyle: { cursor: "pointer" },
                        attrs: { src: file.url },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("check-image", file.id)
                          },
                        },
                      })
                    })
                  }),
                ],
            _c(
              "div",
              { staticClass: "album-gallery__load-more" },
              [
                _vm.hasMore
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text", loading: _vm.loadMoreLoading },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("load-more")
                          },
                        },
                      },
                      [_vm._v(" 載入更多 ")]
                    )
                  : _c("span", [_vm._v("已載入全部照片")]),
              ],
              1
            ),
          ],
          2
        )
      : _vm.loadMoreLoading
      ? _c("div", { staticClass: "album-gallery__empty" }, [
          _c("i", { staticClass: "el-icon-loading" }),
          _vm._v(" 載入相簿中... "),
        ])
      : _c("div", { staticClass: "album-gallery__empty" }, [
          _c("span", [_vm._v("查無資料")]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }